/**
 * Alerte la plus prioritaire sur la fin d’abonnement (bientôt expiré / expiré).
 * @param {Array<{ endDate?: string, status?: string }>|undefined} subscriptions
 * @returns {{ level: 'expired'|'1d'|'7d'|'30d', endDate: string, days?: number } | null}
 */
export function getSubscriptionAccessAlert(subscriptions) {
  if (!subscriptions?.length) return null

  const parse = (str) => {
    if (!str || typeof str !== "string") return null
    const p = str.split("-").map(Number)
    if (p.length < 3 || p.some((n) => Number.isNaN(n))) return null
    return new Date(p[0], p[1] - 1, p[2])
  }

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const msDay = 86400000

  const withDates = subscriptions
    .map((s) => ({ ...s, end: parse(s.endDate) }))
    .filter((s) => s.end && !Number.isNaN(s.end.getTime()))

  if (!withDates.length) return null

  const notExpired = withDates.filter((s) => {
    const e = new Date(s.end)
    e.setHours(0, 0, 0, 0)
    return e >= today
  })

  if (notExpired.length === 0) {
    withDates.sort((a, b) => b.end - a.end)
    return { level: "expired", endDate: withDates[0].endDate }
  }

  notExpired.sort((a, b) => a.end - b.end)
  const s = notExpired[0]
  const end = new Date(s.end)
  end.setHours(0, 0, 0, 0)
  const days = Math.round((end - today) / msDay)
  if (days <= 1) return { level: "1d", endDate: s.endDate, days }
  if (days <= 7) return { level: "7d", endDate: s.endDate, days }
  if (days <= 30) return { level: "30d", endDate: s.endDate, days }
  return null
}
